export const EquationCardEffect = () =>{
    return(
        <div className="container">
            <p>数式エディタのカードの効果の有効かを示します</p>
            <img src={`${process.env.PUBLIC_URL}/equation_card_effect.png`}></img>
            <p>図の例ではカードのモンスター効果(1)が有効のものをしていしています</p>
            </div>
    )
}
